import axios from "axios";

const api = () => {
    const authSession = JSON.parse(localStorage.getItem('auth'));

    const defaultOptions = {
        baseURL: localStorage.getItem('api_url'),
        headers: { 'Content-Type': 'application/json' }
    };

    let instance = axios.create(defaultOptions);

    instance.interceptors.request.use(function (request) {
        const arrUrl = ['auth/login'];

        if (authSession != null) {
            if (!arrUrl.includes(request.url)) {
                request.headers.Authorization = `Bearer ${authSession?.token}`;
            }
        }

        return request;
    });

    instance.interceptors.response.use(function (response) {
        if (response.status === 401) {
            window.location = '/error-401';
        }

        return response;
    });

    instance.interceptors.response.use(function (response) {
        return response;
    },
        function (error) {
            if (401 === error.response?.status) {
                const tokenExpired = localStorage.getItem('token_expired') || '';

                if (tokenExpired !== '') {
                    if (tokenExpired === 'true') {
                        alert("Your access token was expired or invalid. Please log on again to continue.");

                        localStorage.setItem('token_expired', 'true');
                        window.location = '/auth/login';
                    }
                }
            }
            else
                return Promise.reject(error);
        });

    return instance;
};

export default api();
